
import Vue from "vue";
import Component from "vue-class-component";
import { UserModule } from "@/store/modules/user";
import { NotificationModule } from "@/store/modules/notification";
@Component({
  components: {},
})
export default class Header extends Vue {
  userDetail = UserModule.userDetail;
  notification = NotificationModule.countNewNotif;
}
